export class UserQrRequest{
    user: string;
    s_ins: number;
    s_cont: number;
    cix: number;
    qr_code: string;
    opc: number;

    constructor(user: string, s_ins: number, s_cont: number, cix: number, qr_code: string, opc: number){
            this.user = user;
            this.s_ins = s_ins;
            this.s_cont = s_cont;
            this.cix = cix;
            this.qr_code = qr_code;
            this.opc = opc;
    }
}